<template>
  <div class="data-grid-form cols">
    <div class="rows mobile-cols">
      <div class="half">
        <label for="companyName">
          {{ $t('settings.on-board.users.form.company-name') }}
        </label>
        <input
            id="companyName"
            class="stretch"
            :class="{'is-invalid': showStateByField('name') === false}"
            v-model="companyName"
        />
      </div>
      <div class="half">
        <label for="companyAddress">
          {{ $t('settings.on-board.users.form.company-address') }}
        </label>
        <input
            id="companyAddress"
            class="stretch"
            :class="{'is-invalid': showStateByField('address') === false}"
            v-model="companyAddress"
        />
      </div>
    </div>
    <div class="rows mobile-cols">
      <div class="half">
        <label for="companyPic">
          {{ $t('settings.on-board.users.form.company-pic') }}
        </label>
        <input
            id="companyPic"
            class="stretch"
            :class="{'is-invalid': showStateByField('pic') === false}"
            v-model="companyPic"
        />
      </div>
      <div class="half">
        <label for="companyManagerName">
          {{ $t('settings.on-board.users.form.company-manager-name') }}
        </label>
        <input
            id="companyManagerName"
            class="stretch"
            :class="{'is-invalid': showStateByField('managerName') === false}"
            v-model="companyManagerName"
        />
      </div>
    </div>
    <fieldset>
      <legend>{{ $t('settings.on-board.users.form.legal-entity-data') }}</legend>
      <div class="rows mobile-cols">
        <div class="half">
          <label for="legalEntityIdentityNumber">
            {{ $t('settings.on-board.users.form.legal-entity-identity-number') }}
          </label>
          <input
              id="legalEntityIdentityNumber"
              class="stretch"
              :class="{'is-invalid': showStateByField('legalEntityIdentityNumber') === false}"
              v-model="legalEntityIdentityNumber"
          />
        </div>
        <div class="half">
          <label for="legalEntityDocumentNumber">
            {{ $t('settings.on-board.users.form.legal-entity-document-number') }}
          </label>
          <input
              id="legalEntityDocumentNumber"
              class="stretch"
              :class="{'is-invalid': showStateByField('legalEntityDocumentNumber') === false}"
              v-model="legalEntityDocumentNumber"
          />
        </div>
      </div>
    </fieldset>
    <div class="rows mobile-cols">
      <div class="half">
        <label for="companyWorkHoursStart">
          {{ $t('settings.on-board.users.form.company-work-hours-start') }}
        </label>
        <Datepicker
            id="companyWorkHoursStart"
            v-model="companyWorkHoursStartData"
            time-picker
            auto-apply
        />
      </div>
      <div class="half">
        <label for="companyWorkHoursEnd">
          {{ $t('settings.on-board.users.form.company-work-hours-end') }}
        </label>
        <Datepicker
            id="companyWorkHoursEnd"
            v-model="companyWorkHoursEndData"
            time-picker
            auto-apply
        />
      </div>
    </div>
    <div class="rows mobile-cols">
      <div class="quarter pr-5">
        <label for="dashboardDeviceColumns">
          {{ $t('settings.on-board.users.form.company-dashboard-device-columns') }}
        </label>
        <ChooseDashboardDeviceColumn id="dashboardDeviceColumns"
                                     class="dashboard-device-columns"
                                     v-model="dashboardDeviceColumns" />
      </div>
      <div class="quarter">
        <label for="dashboardQuickMapInfoFields">
          {{ $t('settings.on-board.users.form.company-dashboard-quick-map-info-fields') }}
        </label>
        <ChooseDashboardQuickMapInfoField id="dashboardQuickMapInfoFields"
                                          class="dashboard-quick-map-info-fields"
                                          v-model="dashboardQuickMapInfoFields" />
      </div>
    </div>
    <div class="rows mobile-cols">
      <div class="full">
        <input type="checkbox"
               id="showZonesInManagement"
               class="big-check-box"
               v-model="showZonesInDashboard"
        />
        <label for="showZonesInManagement">
          {{ $t('settings.on-board.users.show-zones-in-management') }}
        </label>
      </div>
    </div>
    <div class="rows mobile-cols">
      <div class="half">
        <label>
          {{ $t('settings.on-board.users.check-violations') }}:
        </label>
        <div class="rows">
          <div>
            <input type="radio"
                   id="trafficViolationsRequestTypeAsPhysicalPerson"
                   name="trafficViolationsRequestType"
                   :value="TrafficViolationsRequestType.AsPhysicalPerson"
                   class="big-check-box"
                   v-model="trafficViolationsRequestType"
            />
            <label for="trafficViolationsRequestTypeAsPhysicalPerson">
              {{ $t('settings.on-board.users.physical-person') }}
            </label>
          </div>
          <div>
            <input type="radio"
                   id="trafficViolationsRequestTypeAsCompany"
                   name="trafficViolationsRequestType"
                   :value="TrafficViolationsRequestType.AsCompany"
                   class="big-check-box"
                   v-model="trafficViolationsRequestType"
            />
            <label for="trafficViolationsRequestTypeAsCompany">
              {{ $t('settings.on-board.users.company') }}
            </label>
          </div>
          <div>
            <input type="radio"
                   id="trafficViolationsRequestTypeNoRequest"
                   name="trafficViolationsRequestType"
                   :value="TrafficViolationsRequestType.NoRequest"
                   class="big-check-box"
                   v-model="trafficViolationsRequestType"
            />
            <label for="trafficViolationsRequestTypeNoRequest">
              {{ $t('settings.on-board.users.no-validation') }}
            </label>
          </div>
        </div>
      </div>
      <div class="half rows justify-end mobile-justify-start">
        <div>
          <input type="checkbox"
                 id="showDeviceNotifications"
                 class="big-check-box"
                 v-model="showDeviceNotifications"
          />
          <label for="showDeviceNotifications">
            {{ $t('settings.on-board.users.show-device-notifications') }}
          </label>
        </div>
      </div>
    </div>
    <div>
      <button type="submit" class="button-save" @click="save">
        {{ $t('generic.save') }}
      </button>
    </div>
    <div>
      <DataGrid
          :actions-header="$t('settings.on-board.users.drivers')"
          :data-model="driversDataGridModel"
          :data="driversData"
          :selected-id="selectedDriverId"
          allow-add
          allow-edit
          allow-delete
          @on-select="onDriverSelect"
          @on-delete="onDriverDelete"
      />
      <div class="rows" v-if="isDriverEditMode">
        <div>
          <label for="driverName">
            {{ $t('settings.on-board.users.name') }}
          </label>
          <input
              id="driverName"
              maxlength="128"
              required
              class="stretch"
              :class="{'is-invalid': showStateByField('driver-name') === false}"
              v-model="driverName"
          />
        </div>
        <div>
          <label for="driverPhoneNumber">
            {{ $t('settings.on-board.users.phone-number') }}
          </label>
          <input
              id="driverName"
              required
              class="stretch"
              :class="{'is-invalid': showStateByField('driver-phone') === false}"
              v-model="driverPhoneNumber"
              v-maska data-maska="+359#########" placeholder="+359888888888"
          />
        </div>
        <div>
          <label for="driverBeacon">
            {{ $t('settings.on-board.users.beacon') }}
          </label>
          <input
              id="driverBeacon"
              maxlength="128"
              required
              class="stretch"
              :class="{'is-invalid': showStateByField('driver-beacon') === false}"
              v-model="driverBeacon"
          />
        </div>
        <div class="pt-30">
          <button class="button-save" @click="onDriverSave">
            {{ $t('generic.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {dataManipulator, entityDataManager} from "@/assets/js/data-manipulation";
import {actions} from "@/assets/js/vue/vuex/actions";
import notification from "@/assets/js/notification";
import Datepicker from "@vuepic/vue-datepicker";
import {TrafficViolationsRequestType} from "@/assets/js/enums/TrafficViolationsRequestType.ts";
import DataGrid from "@/components/pages/partials/DataGrid.vue";
import {vMaska} from "maska/dist/vue"
import {popups} from "@/assets/js/popups";
import ChooseDashboardDeviceColumn from "@/components/pages/partials/ChooseDashboardDeviceColumn.vue";
import ChooseDashboardQuickMapInfoField from "@/components/pages/partials/ChooseDashboardQuickMapInfoField.vue";
import {DashboardQuickMapInfoField} from "@/assets/js/enums/DashboardQuickMapInfoField.js";

const NewDriverIdKey = 'newDriver';

export default {
  name: 'Client',
  components: {ChooseDashboardQuickMapInfoField, ChooseDashboardDeviceColumn, DataGrid, Datepicker},
  directives: { maska: vMaska },
  data() {
    return {
      fieldStates: {},

      companyName: null,
      companyAddress: null,
      companyPic: null,
      companyManagerName: null,
      legalEntityIdentityNumber: null,
      legalEntityDocumentNumber: null,
      companyWorkHoursStartData: {
        hours: 9,
        minutes: 0,
        seconds: 0,
      },
      companyWorkHoursEndData: {
        hours: 18,
        minutes: 0,
        seconds: 0,
      },
      dashboardDeviceColumns: [],
      dashboardQuickMapInfoFields: [],
      showZonesInDashboard: false,
      showDeviceNotifications: null,
      trafficViolationsRequestType: null,

      driversData: [],
      selectedDriverId: null,
      isDriverEditMode: false,
      driverName: null,
      driverPhoneNumber: null,
      driverBeacon: null
    }
  },
  computed: {
    ...mapState(['users', 'companies', 'lastErrorDetails', 'drivers']),
    ...mapGetters(['userCompany']),
    TrafficViolationsRequestType() {
      return TrafficViolationsRequestType
    },
    driversDataGridModel() {
      return {
        headers: {
          [this.$t('settings.on-board.users.name')]: 'name',
          [this.$t('settings.on-board.users.phone-number')]: 'phoneNumber',
          [this.$t('settings.on-board.users.beacon')]: 'uniqueId',
        },
      };
    },
  },
  mounted() {
    this.fillForm();
    this.initDriversGrid();
  },
  watch: {
    userCompany() {
      this.fillForm();
    },
    drivers() {
      this.initDriversGrid();
    }
  },
  methods: {
    initDriversGrid() {
      this.driversData = this.drivers;
    },
    fillForm() {
      const company = this.userCompany;
      if (!company) {
        return;
      }

      this.companyName = company.name;
      this.companyAddress = company.address;
      this.companyPic = company.pic;
      this.companyManagerName = company.managerName;
      this.legalEntityIdentityNumber = company.legalEntityIdentityNumber;
      this.legalEntityDocumentNumber = company.legalEntityDocumentNumber;
      this.companyWorkHoursStartData = dataManipulator.timeStringToObj(company.workHoursStart);
      this.companyWorkHoursEndData = dataManipulator.timeStringToObj(company.workHoursEnd);
      this.dashboardDeviceColumns = company.attributes?.dashboardDeviceColumns ?? [];
      this.dashboardQuickMapInfoFields = company.attributes?.dashboardQuickMapInfoFields ?? DashboardQuickMapInfoField.values();
      this.showZonesInDashboard = company.attributes?.showZonesInDashboard ?? false;
      this.showDeviceNotifications = company.showDeviceNotifications;
      this.trafficViolationsRequestType = company.trafficViolationsRequestType;
    },
    showDirtyFields() {
      this.fieldStates = {};

      if (this.lastErrorDetails === null) {
        return;
      }

      this.lastErrorDetails.forEach(error => {
        if (error.field !== undefined) {
          this.fieldStates[error.field] = false;
        }
      });
    },
    showStateByField(field) {
      return entityDataManager.getStateByField(this.fieldStates, field);
    },
    onDriverSelect(driverId) {
      this.selectedDriverId = driverId;
      this.isDriverEditMode = true;

      this.driverName = '';
      this.driverPhoneNumber = '';
      this.driverBeacon = '';

      if (driverId === null) {
        return;
      }

      const driver = this.driversData.find(x => x.id === driverId);
      if (!driver) {
        return;
      }

      this.driverName = driver.name;
      this.driverPhoneNumber = driver.phoneNumber;
      this.driverBeacon = driver.supportsBeacon ? driver.uniqueId : '';
    },
    async onDriverSave() {
      if (!this.validateDriver()) {
        return;
      }

      if (this.selectedDriverId) {
        await this.onDriverEdit(this.selectedDriverId)
      }
      else {
        await this.onDriverCreate();
      }
    },
    async onDriverCreate() {
      const driver = this.populateDriverData();

      await this.$store.dispatch(actions.CREATE_DRIVER, driver)
          .then(() => this.$store.dispatch(actions.GET_DRIVERS))
          .then(() => {
            this.initDriversGrid();
            notification.success(this.$t('generic.save.success'));
            this.isDriverEditMode = false;
          })
          .catch(e => notification.error(this.$t(e.message)))
          .finally(() => this.showDirtyFields());
    },
    async onDriverEdit(driverId) {
      const driverIndex = this.driversData.findIndex(x => x.id === driverId);
      if (driverIndex === -1) {
        return;
      }

      const driver = this.populateDriverData(this.driversData[driverIndex]);

      await this.$store.dispatch(actions.UPDATE_DRIVER, driver)
          .then(() => this.$store.dispatch(actions.GET_DRIVERS))
          .then(() => {
            this.initDriversGrid();
            notification.success(this.$t('generic.save.success'));
            this.isDriverEditMode = false;
          })
          .catch(e => notification.error(this.$t(e.message)))
          .finally(() => this.showDirtyFields());
    },
    onDriverDelete(driverId) {
      const driverIndex = this.driversData.findIndex(x => x.id === driverId);
      if (driverIndex === -1) {
        return;
      }

      popups.yesNoConfirmation(this.$swal, this.$t('generic.delete.confirm'))
          .then(async result => {
            if (!result.isConfirmed) {
              return;
            }

            this.isDriverEditMode = false;

            await this.$store.dispatch(actions.REMOVE_DRIVER, {id: driverId})
                .then(() => this.$store.dispatch(actions.GET_DRIVERS))
                .then(() => {
                  this.initDriversGrid();
                  notification.success(this.$t('generic.delete.success'));
                })
                .catch(e => notification.error(this.$t(e.message)));
          });
    },
    async save() {
      const companyPayload = {
        name: this.companyName,
        address: this.companyAddress,
        pic: this.companyPic,
        managerName: this.companyManagerName,
        legalEntityIdentityNumber: this.legalEntityIdentityNumber,
        legalEntityDocumentNumber: this.legalEntityDocumentNumber,
        showDeviceNotifications: this.showDeviceNotifications,
        trafficViolationsRequestType: (isNaN(this.trafficViolationsRequestType) ? 0 : parseInt(this.trafficViolationsRequestType)),
        allowFullVehicleEdit: this.userCompany.allowFullVehicleEdit,
        workHoursStart: dataManipulator.timeObjToString(this.companyWorkHoursStartData),
        workHoursEnd: dataManipulator.timeObjToString(this.companyWorkHoursEndData),
        attributes: {
          ...(this.userCompany.attributes ?? {}),
          dashboardDeviceColumns: this.dashboardDeviceColumns,
          dashboardQuickMapInfoFields: this.dashboardQuickMapInfoFields,
          showZonesInDashboard: this.showZonesInDashboard,
        }
      };

      const fetchViolations =
          (this.userCompany.pic !== this.companyPic ||
              this.userCompany.trafficViolationsRequestType !== this.trafficViolationsRequestType ||
              this.userCompany.legalEntityIdentityNumber !== this.legalEntityIdentityNumber ||
              this.userCompany.legalEntityDocumentNumber !== this.legalEntityDocumentNumber) &&
          entityDataManager.shouldFetchViolations(companyPayload);

      await this.$store.dispatch(actions.EDIT_USER_COMPANY_DATA, companyPayload)
          .then(() => {
            notification.success(this.$t('generic.save.success'));
            if (fetchViolations) {
              this.$store.dispatch(actions.CHECK_VIOLATIONS)
                  .catch(e => notification.error(this.$t(e.message)));
            }
          })
          .catch(e => notification.error(this.$t(e.message)))
          .finally(() => this.showDirtyFields());
    },
    validateDriver() {
      delete this.fieldStates['driver-name'];
      delete this.fieldStates['driver-phone'];

      const errors = {};
      if (!this.driverName) {
        errors['driver-name'] = false;
      }

      if (!this.driverPhoneNumber || this.driverPhoneNumber.length !== 13) {
        errors['driver-phone'] = false;
      }

      if (Object.keys(errors).length !== 0) {
        this.fieldStates = {...this.fieldStates, ...errors};
        return false;
      }

      return true;
    },
    populateDriverData(driver = {}) {
      driver.name = this.driverName;
      driver.phoneNumber = this.driverPhoneNumber;

      if (this.driverBeacon) {
        driver.uniqueId = this.driverBeacon;
        driver.supportsBeacon = true;
      }
      else {
        driver.uniqueId = '';
        driver.supportsBeacon = false;
      }

      return driver
    },
    getDriversWithNoRandomId(drivers) {
      return drivers.map(x => {
        if (`${x.id}`.includes(NewDriverIdKey)) {
          x.id = 0;
        }

        return x;
      })
    }
  },
}
</script>

<style scoped lang="scss">
.show-device-notifications {
  text-align: end;
}
</style>
